import React from 'react';
import { AlertCircle } from 'lucide-react';

interface SkillsAsyncStateProps {
  loading: boolean;
  error?: string | null;
  onRetry: () => void;
  retryLabel: string;
  children: React.ReactNode;
}

export const SkillsAsyncState = ({
  loading,
  error,
  onRetry,
  retryLabel,
  children,
}: SkillsAsyncStateProps) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-6 w-6 border-2 border-brand-dark border-t-transparent" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <AlertCircle className="h-8 w-8 text-red-500 mb-2" />
        <p className="text-sm text-[#252F33]">{error}</p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 text-sm text-brand-link hover:underline">
          {retryLabel}
        </button>
      </div>
    );
  }

  return <>{children}</>;
};
